// 国际化
import langs from "@/i18n/langs.json"

export const LANG = "language"
export const useLangeageStore = defineStore("langeage", () => {
  const language = ref(localStorage.getItem(LANG) || "zhCn")
  const language_list = ref(langs)
  function setLanguage(lang: string) {
    // 设置缓存
    localStorage.setItem(LANG, lang)
    // 修改状态
    language.value = lang
  }
  return { language, language_list, setLanguage }
})
